import React, { createContext, useContext, useLayoutEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'

import { RULES, validRule } from '../../../../../constants/Entitlements'
import { useSearchParams } from '../../../../../hooks'
import { createValidationSchema } from '../helpers/validationSchemas'

const CreateActionContext = createContext(null)

export const CreateActionProvider = ({ children }) => {
  const [isPreview, setIsPreview] = useState(false)
  const [isReadOnly, setIsReadOnly] = useState(false)
  const [validationSchema, setValidationSchema] = useState(createValidationSchema())

  const [searchParams] = useSearchParams()
  const currentUser = useSelector((state) => state.auth.auth)
  const params = useParams()
  const history = useHistory()

  const actionId = params.id
  const isNewAction = !actionId

  useLayoutEffect(function onMount() {
    const hasAccess = validRule(RULES.ACTION)
    if (!hasAccess) return history.push('/home')

    const readOnly = searchParams.get('readOnly')
    setIsReadOnly(readOnly === true || isPreview)
  }, [])

  return (
    <CreateActionContext.Provider
      value={{
        isNewAction,
        actionId,
        currentUser,
        isPreview,
        setIsPreview,
        isReadOnly,
        setIsReadOnly,
        validationSchema,
        setValidationSchema
      }}
    >
      {children}
    </CreateActionContext.Provider>
  )
}

export const useCreateActionContext = () => {
  const context = useContext(CreateActionContext)

  if (!context) {
    throw new Error('useCustomFields must be used with an CustomFieldsProvider')
  }

  return context
}
